import { z } from "zod";
import { fileSchema } from "../files";

export const EmailGenerationSchema = z.object({
  mailContent: z.string(),
  mailObject: z.string(),
  mailPreview: z.string(),
  mailTarget: z.string(),
  isAdvancedStatisticsPromoted: z.boolean(),
  isTicketingPromoted: z.boolean(),
  isAccessCountrolAccountPromoted: z.boolean(),
  isDetailedExhibitorProfilesPromoted: z.boolean(),
  isEventPromotionPromoted: z.boolean(),
  mailPictures: fileSchema.array(),
});

export type EmailGenerationForm = z.infer<typeof EmailGenerationSchema>;

export const emailGenerationFormDefaultValues: EmailGenerationForm = {
  mailContent: "",
  mailObject: "",
  mailPreview: "",
  mailTarget: "",
  isAdvancedStatisticsPromoted: false,
  isTicketingPromoted: false,
  isAccessCountrolAccountPromoted: false,
  isDetailedExhibitorProfilesPromoted: false,
  isEventPromotionPromoted: false,
  mailPictures: [],
};
